import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Paperclip, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { fileUrl } from "../../lib/api";
import { rcApi, errMsg, fmt, TYPE_AR, STATUS_AR, SOURCE_AR } from "./rcApi";

const TONE = { collect: "text-rose-600", deposit: "text-emerald-600", deduct: "text-amber-600" };

export const TxnRow = ({ t, onDelete }) => (
  <tr className="border-b last:border-0" data-testid={`rc-txn-${t.id}`}>
    <td className="p-2 whitespace-nowrap">{t.date}</td>
    <td className={`p-2 font-medium ${TONE[t.type]}`}>{TYPE_AR[t.type]}</td>
    <td className="p-2 tabular-nums">{fmt(t.amount)}</td>
    <td className="p-2 text-xs text-slate-500">{SOURCE_AR[t.source] || t.source}</td>
    <td className="p-2 text-xs">{STATUS_AR[t.status]}{t.journal_number ? <span className="block text-slate-400">قيد {t.journal_number}</span> : null}</td>
    <td className="p-2 text-xs text-slate-500">{t.note || t.reject_reason || ""}</td>
    <td className="p-2">
      <div className="flex gap-1">
        {t.file_id && <a href={fileUrl(t.file_id)} target="_blank" rel="noreferrer" data-testid={`rc-txn-file-${t.id}`}><Paperclip className="h-4 w-4 text-blue-600" /></a>}
        {onDelete && t.type !== "deduct" && <button data-testid={`rc-txn-del-${t.id}`} onClick={() => onDelete(t)}><Trash2 className="h-4 w-4 text-rose-500" /></button>}
      </div>
    </td>
  </tr>
);

export const TxnTable = ({ txns, onDelete }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-right text-sm">
      <thead className="bg-slate-50 text-xs text-slate-500"><tr>{["التاريخ", "النوع", "المبلغ", "المصدر", "الحالة", "ملاحظة", ""].map((h, i) => <th key={i} className="p-2 font-medium">{h}</th>)}</tr></thead>
      <tbody>{txns.map((t) => <TxnRow key={t.id} t={t} onDelete={onDelete} />)}</tbody>
    </table>
    {!txns.length && <p className="p-6 text-center text-sm text-slate-400">لا توجد حركات</p>}
  </div>
);

export const RiderCashLedgerDialog = ({ row, onClose, onChanged }) => {
  const [txns, setTxns] = useState([]);
  const load = useCallback(() => rcApi.txns({ employee_id: row.employee_id }).then(setTxns).catch(() => setTxns([])), [row.employee_id]);
  useEffect(() => { load(); }, [load]);
  const del = async (t) => {
    if (!window.confirm("حذف هذه الحركة؟ سيتم عكس القيد المحاسبي إن وجد.")) return;
    try { await rcApi.remove(t.id); toast.success("تم الحذف"); load(); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent dir="rtl" className="sm:max-w-3xl max-h-[85vh] overflow-y-auto font-body" data-testid="rc-ledger-dialog">
        <DialogHeader className="text-right"><DialogTitle className="font-heading">كشف نقد — {row.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">الرصيد المستحق: <b className="text-rose-600" data-testid="rc-ledger-balance">{fmt(row.balance)}</b> ريال</p>
        <TxnTable txns={txns} onDelete={del} />
      </DialogContent>
    </Dialog>
  );
};
